import { defineMessages } from 'react-intl';

export default defineMessages({
  classClassification: {
    id: 'reports.application.details.reportCard.classClassification',
    defaultMessage: 'Class Classification',
  },
  generalClassification: {
    id: 'reports.application.details.reportCard.generalClassification',
    defaultMessage: 'General Classification',
  },
  schoolGrade: {
    id: 'reports.application.details.reportCard.schoolGrade',
    defaultMessage: 'School Grade',
  },
  percentage: {
    id: 'reports.application.details.reportCard.percentage',
    defaultMessage: 'Percentage',
  },
  participants: {
    id: 'reports.application.details.reportCard.participants',
    defaultMessage: 'Participants',
  },
  print: {
    id: 'reports.application.details.reportCard.print',
    defaultMessage: 'Print',
  },
  school: {
    id: 'reports.application.details.reportCard.school',
    defaultMessage: 'School',
  },
  studentPerformanceByQuestion: {
    id: 'reports.application.details.reportCard.studentPerformanceByQuestion',
    defaultMessage: 'Student performance by question',
  },
  answer: {
    id: 'reports.application.details.reportCard.answer',
    defaultMessage: 'Answer',
  },
  correct: {
    id: 'reports.application.details.reportCard.correct',
    defaultMessage: 'Correct',
  },
  loadReportsCard: {
    id: 'reports.application.details.reportCard.loadReportsCard',
    defaultMessage: 'To load the reports, you must select the Course and Student.',
  },
  batchPdf: {
    id: 'reports.application.details.reportCard.batchPdf',
    defaultMessage: 'Generate batch',
  },
  filenameStudentPdf: {
    id: 'reports.application.details.reportCard.filenameStudentPdf',
    defaultMessage: 'student',
  },
  filenameBatchStudentPdf: {
    id: 'reports.application.details.reportCard.filenameBatchStudentPdf',
    defaultMessage: 'batch',
  },
  loadingMessage: {
    id: 'reports.application.details.reportCard.loadingMessage',
    defaultMessage:
      'The report card are being generated and, depending on the number of students, this process may take a few minutes to complete, please wait ...',
  },
  titleStudent: {
    id: 'reports.application.details.reportCard.titleStudent',
    defaultMessage: 'Report',
  },
});
